export default {"src":"/_next/static/media/arrow-down.3d46a727.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};